<div class="ipm-container">

  <!-- Header -->
  <div class="ipm-header">
    <h2 class="ipm-title">Import Missing Test Cases</h2>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="onCancel()"
      aria-label="Close">
      <img
        [src]="isActive ? 'assets/images/virtusa-icons/close-dark.svg' : 'assets/images/virtusa-icons/close.svg'"
        alt="Close"/>
    </button>
  </div>

  <!-- Accordion wrapper — search floats into the accordion's own header row -->
  <div class="ipm-accordion-wrapper">

    <!-- Overlaid search box — sits in the right side of the accordion header -->
    <div class="ipm-inline-search">
      <div class="ipm-search-wrapper">
        <svg class="ipm-search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="7" cy="7" r="5" stroke="#A1A4A9" stroke-width="1.5"/>
          <path d="M11 11l3 3" stroke="#A1A4A9" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <input
          type="text"
          class="ipm-search"
          placeholder="Search..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
          aria-label="Search test cases"/>
      </div>
    </div>

    <app-expandable-accordion
      [data]="accordionData"
      [showSelectAll]="true"
      [showEmptyState]="true"
      [showFeedbackActions]="false"
      [showStoryIdLink]="false"
      [showEditButton]="false"
      [showFilterButton]="false"
      [showDownloadButton]="false"
      [showDeleteButton]="false"
      [showAddMissingButton]="false"
      [showAddToSuiteButton]="false"
      [pageSize]="10"
      (actionEmit)="onAccordionAction($event)"
    ></app-expandable-accordion>
  </div>

  <div #errorPanel class="ipm-error-wrap" *ngIf="validationErrors.length || addError">
    <app-import-validation-error-panel
      [groups]="validationErrors"
      [summary]="validationSummary"
      [duplicateNote]="duplicateNote">
    </app-import-validation-error-panel>
    <p class="ipm-error" *ngIf="addError">{{ addError }}</p>
  </div>

  <!-- Footer -->
  <div class="ipm-footer">
    <p class="ipm-step">Step 3 of 3</p>
    <div class="ipm-footer-actions">
      <button type="button" class="btn-accello-secondary" [disabled]="isAdding" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        class="btn-accello-primary-light d-inline-flex align-items-center gap-2"
        [disabled]="!canAdd"
        (click)="onAddToSuite()">
        <span *ngIf="isAdding" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        {{ isAdding ? 'Adding...' : 'Add' }}
      </button>
    </div>
  </div>

</div>
